import { ExamineeListModel } from './../../../shared/models/examinee-list.model';
// services/exam.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '@tsin-env/environment';
import { ExamType } from '@tsin-core/entities';
import { IExam, IExamCreate, IExamList, IExamPool } from '@tsin-core/models/exam.model';
import { IApplication, IExaminee, IExamineeShort } from '@tsin-core/models/application.model';
import { ExamProgramType } from '@tsin-shared/models/examType.model';

const APPLICATION_URL = `${environment.apiUrl}/applications`;
const EXAMS_URL = `${environment.apiUrl}/exams`;
const APPLICATION_SINGLE_URL = `${environment.apiUrl}/application`;
// /api/applications/exam/{id}
// 'https://vj2np9pdd6.us-east-1.awsapprunner.com/api/exams',

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {

  private http: HttpClient = inject(HttpClient);

  //   getApplicationByExamId(id: string) {
  //     return this.http.get<any>(
  //       `${APPLICATION_URL}${'678e2e3931cb12670f839463'}`
  //     );
  //   }

  public getAllApplications(options: any): Observable<{ items: ExamineeListModel[] }> {
    const query = new HttpParams({ fromObject: options });
    console.log('Query Params:', query.toString());
    return this.http.get<{ items: ExamineeListModel[] }>(APPLICATION_URL, { params: query }).pipe(shareReplay(1));
  }

  getExamApplicants(examId: string): Observable<{ data: IExaminee[] }> {
    // return this.http.get<{ data: IExaminee[] }>(`${APPLICATION_URL}/exam/${examId}`);
    return this.http.get<{ data: IExaminee[] }>(`${APPLICATION_URL}`, {
      params: {
        examId,
        status: ''
      }
    });
  }

  getUserApplications(userId: string): Observable<{ data: IApplication[] }> {
    return this.http.get<{ data: IApplication[] }>(`${APPLICATION_URL}/user/${userId}`);
  }


  getSingleUserApplication(userId: string): Observable<{ data: IExamList }> {
    return this.http.get<{ data: IExamList }>(`${APPLICATION_URL}/user/${userId}`);
  }


  generateDryRunApplications(payload: { examId: string, numberOfApplications: number }): Observable<any> {
    return this.http.post(`${APPLICATION_URL}/generate-dry-run-applications`, {
      examId: payload.examId,
      numberOfApplications: payload.numberOfApplications
    });
  }

  addExamApplication(examApplicationData: any): Observable<any> {
    return this.http.post<any>(APPLICATION_URL, examApplicationData);
  }

  getApplicationsByExam(examId: string): Observable<any> {
    return this.http.get<any>(`${APPLICATION_URL}/exam/${examId}`);
  }

  checkIsUserHasRegistrationsToExamType(type: ExamProgramType) {
    return this.http.get(APPLICATION_URL, {
      params: {
        type,
      }
    })
  }

  public getAllExamApplications() {
    return this.http.get(APPLICATION_URL);
  }

  getExamApplicantsShort(examId: string): Observable<{ data: IExamineeShort[] }> {
    return this.http.get<{ data: IExamineeShort[] }>(`${APPLICATION_URL}/exam/${examId}`);
  }

  getSingleExamApplicant(id: string): Observable<{ data: IExamineeShort[] }> {
    return this.http.get<{ data: IExamineeShort[] }>(`${APPLICATION_SINGLE_URL}/user/${id}`);
  }

  addExam(exam: Omit<IExamCreate, 'id'>): Observable<IExamList> {
    return this.http.post<IExamList>(APPLICATION_URL, exam);
  }

  updateExam(exam: IExamCreate): Observable<IExamList> {
    return this.http.post<IExamList>(APPLICATION_URL, exam);
  }

  deleteExam(id: string): Observable<void> {
    return this.http.delete<void>(`${APPLICATION_URL}/single/${id}`);
  }

  updateExamineeStatus(payload: {
    examId: string;
    status: 'pending' | 'registered' | 'examChallenged' | 'cancelled';
    applicationIds: string[];
  }): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(`${APPLICATION_URL}/update-examinee-status`, payload);
  }

  reassignExaminee(payload: {
    examId: string;
    applicationIds: string[];
  }): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${EXAMS_URL}/reassign-examinee`, payload);
  }
}
